enum JobType {
  FUNDING_SCHEDULE = "FUNDING_SCHEDULE",
  TRANSFER_SCHEDULE = "TRANSFER_SCHEDULE",
}

export default JobType;
